export * from "-!../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./employee.vue?vue&type=template&id=17aee1a4"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/vue/components/employee.vue?vue&type=template&id=17aee1a4
// module id = 39
// module chunks = 0